import React from 'react';

import { LoadingCircle } from '@icarros/ids-react';

import './Loading.scss';

const LoadingComponent = () => (
  <div className="loading-component__container" title="ícone de carregamento">
    <LoadingCircle />
  </div>
);

export default LoadingComponent;
